import { defineComponent, watch, h, onUnmounted } from "@vue/composition-api";
import { Transaction } from "@scrile/api-provider/dist/api/TransactionProvider";
import useAuthUser from "@/hooks/useAuthUser";
import useBalance from "@/hooks/useBalance";
import emitter from "@/lib/emitter";
import { EVENTS } from "@/const";

export default defineComponent({
  name: "BalanceManager",
  setup() {
    const { balance, getBalance, setBalance, subscribeBalanceUpdated } = useBalance();
    const { allowAccess } = useAuthUser();
    let unsubscribe: () => void = () => {};

    watch(
      allowAccess,
      (currentAllowAccess, oldAllowAccess) => {
        if (!currentAllowAccess) {
          setBalance(0);
          unsubscribe();
          return;
        }
        if (!oldAllowAccess && currentAllowAccess) {
          getBalance();
          subscribeBalanceUpdated(balance => setBalance(balance)).then(cb => (unsubscribe = cb));
        }
      },
      { immediate: true, deep: true }
    );
    onUnmounted(() => {
      unsubscribe();
    });
    const onRefill = (transaction?: Transaction) => {
      if (transaction && transaction.type === "DEPOSIT") {
        setBalance(balance.value + transaction.amount);
      }
    };
    emitter.on<Transaction>(EVENTS.BALANCE_REFILL_PURCHASED, onRefill);
    onUnmounted(() => emitter.off(EVENTS.BALANCE_REFILL_PURCHASED, onRefill));
    return () => h();
  },
});
